<template>
  <transition name="fade">
    <div class="card">
      <div class="top_button">
        <button @click="$emit('back')">
          <img src="../../../../assets/images/icons/chevron-left-black.svg" alt="">
        </button>
      </div>
      <div v-if="form" class="card_flex">
        <div class="client">
          <div class="avatar">
            <div class="camera">
              <a class="camera-visible" @click="$refs.avatar.click()" v-if="!canChange">
                <img src="@/assets/images/icons/camera-setting.svg" alt="Изменить">
              </a>
              <img :src="avatar" v-if="avatar">
              <input hidden type="file" @change="setAvatar" ref="avatar">
            </div>
            <error-text :text="errors.avatar"/>
          </div>
          <div>
            <h4>Имя</h4>
            <input :disabled="canChange" type="text" v-model="form.name">
            <error-text :text="errors.name"/>
          </div>
          <div>
            <h4>Фамилия</h4>
            <input :disabled="canChange" type="text" v-model="form.surname">
            <error-text :text="errors.surname"/>
          </div>
          <div>
            <div class="phone-title">
              <h4>Телефон</h4>
              <a v-if="form.phone" :href="`tel:${form.phone}`">
                <svg enable-background="new 0 0 513.64 513.64" version="1.1" viewBox="0 0 513.64 513.64" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
                  <path d="m499.66 376.96-71.68-71.68c-25.6-25.6-69.12-15.359-79.36 17.92-7.68 23.041-33.28 35.841-56.32 30.72-51.2-12.8-120.32-79.36-133.12-133.12-7.68-23.041 7.68-48.641 30.72-56.32 33.28-10.24 43.52-53.76 17.92-79.36l-71.68-71.68c-20.48-17.92-51.2-17.92-69.12 0l-48.64 48.64c-48.64 51.2 5.12 186.88 125.44 307.2s256 176.64 307.2 125.44l48.64-48.64c17.921-20.48 17.921-51.2 0-69.12z"/>
                </svg>
              </a>
            </div>
            <input :disabled="true" type="text" v-model="form.phone">
            <error-text :text="errors.phone"/>
          </div>
          <div>
            <h4>День рождения</h4>
            <input :disabled="canChange" type="date" v-model="form.date_of_birth">
            <error-text :text="errors.date_of_birth"/>
          </div>
          <div>
            <h4>Заметка</h4>
            <textarea v-model="form.notes" maxlength="120"></textarea>
            <div style="display: flex;">
              <error-text :text="errors.notes"/>
              <small style="display: block; margin-left: auto">{{ form.notes != undefined ? form.notes.toString().length : '0' }}/120</small>
            </div>
          </div>
          <button-component
              :loading="loading"
              variant="filled"
              @click="update"
          >Сохранить
          </button-component>
          <button-component
              variant="outlined"
              v-if="isMobile"
              @click="openModal('cabinet_master_client_history')"
          >История посещений
          </button-component>
        </div>
        <div class="story" v-if="!isMobile">
          <h3>История посещений</h3>
          <template v-if="records.length">
            <div :key="idx" v-for="(storyItem, idx) in records">
              <a href="javascript:void(0)">
                <div class="item" @click.self="storyItem.open = !storyItem.open">
                  <div class="title">
                    <div class="name" @click="storyItem.open = !storyItem.open">
                      {{ storyItem.name }}
                    </div>
                    <div class="date" @click="storyItem.open = !storyItem.open">
                      {{ storyItem.start }}
                    </div>
                  </div>
                  <div class="price" @click="storyItem.open = !storyItem.open">
                    {{ storyItem.price }}
                    <img src="@/assets/images/icons/chevron-down-black.svg"
                         :style="{transition: '0.4s', transform: storyItem.open ?  'rotate(0deg)' : 'rotate(180deg)' }"
                         alt="">
                  </div>
                  <transition name="fade">
                    <div class="client" style="width: 100%" v-if="storyItem.open">
                      <input v-model="storyItem.comment" placeholder="Комментарий" @change="() => updateComment(storyItem)">
                    </div>
                  </transition>
                </div>
              </a>
            </div>
          </template>
          <template v-else>
            <h3 style="text-align: center;margin-top: 50px;color: #38383885">Список пуст</h3>
          </template>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import ButtonComponent from "@/components/ui/buttons/button-component";
import ErrorText from '@/components/ui/text/error-text';
import {mapMutations} from 'vuex'

export default {
  name: 'ClientParams',
  components: {ErrorText, ButtonComponent},
  props: {
    client: [Array, Object],
  },
  data() {
    return {
      loading: false,
      records: {
        data: [],
        page: 1,
        last_page: null,
      },
      avatar: null,
      form: null,
      errors: {},
    }
  },
  computed: {
    canChange() {
      return !this.client.can_change;
    },
    isMobile() {
      return document.documentElement.clientWidth < 1170
    }
  },
  watch: {
    client(to) {
      this.setForm(to);
    }
  },
  mounted() {
    this.setForm(this.client);
  },
  methods: {
    ...mapMutations(['openModal']),
    setForm(data) {
      this.avatar = data.client.avatar;
      this.form = {
        avatar: null,
        name: data.client.name,
        surname: data.client.surname,
        phone: data.client.phone,
        date_of_birth: data.client.date_of_birth ? this.$moment(data.client.date_of_birth, 'DD.MM.YYYY').format('YYYY-MM-DD') : null,
        notes: data.notes,
      };
      this.$api.master.record.list({client_id: data.client.id}).then(({data}) => this.records = data.map(val => {
        val.open = false;
        return val;
      }));
    },
    setAvatar(event) {
      this.errors.avatar = null;
      let instance = this;
      Array.from(event.target.files).forEach((image) => {
        if (!image.type.match('image.*')) return;
        let reader = new FileReader();
        reader.onload = (() => {
          return (e) => instance.avatar = e.target.result;
        })(image);
        reader.readAsDataURL(image);
        instance.form.avatar = image;
      });
    },
    updateComment(record) {
      this.$api.master.record.comment(record.id, {comment: record.comment});
    },
    update() {
      this.loading = true;
      this.$api.master.client.update(this.client.id, this.form).then(({data}) => {
        this.setForm(data);
        this.$emit('updated', data);
        this.$toast.success('Сохранено!');
      }).catch(({response}) => {
        this.errors = response.data.errors;
        this.$toast.error('Проверьте указанные данные!');
      }).finally(() => this.loading = false);
    }
  }
}
</script>
<style scoped lang="scss">
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

.phone-title {
  display: flex;
  align-items: center;
  margin-top: 15px;

  & h4 {
    margin-top: 0;
  }

  & svg {
    height: 17px;
    width: 17px;
    margin-left: 6px;
    fill: #90745b;
  }
}

h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #383838;
  margin: 20px;
}

h4 {
  margin-top: 20px;
  margin-left: 15px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #808080;
}

.card {
  padding: 0;
  background: #FFFFFF;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06), 0px 0px 1px rgba(0, 0, 0, 0.04);
  border-radius: 10px;
  height: 100%;

  &_flex {
    display: flex;
    flex-wrap: wrap;
  }

  .client {
    padding: 25px;
    width: 50%;

    input {
      height: 40px;
      width: 100%;
      background-color: #FFFFFF;
      border: 1px solid #DBBFA7;
      box-sizing: border-box;
      border-radius: 5px;
      padding-left: 15px;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 24px;
      color: #383838;

    }

    textarea {
      height: 40px;
      max-width: 100%;
      min-width: 100%;
      background-color: #FFFFFF;
      border: 1px solid #DBBFA7;
      box-sizing: border-box;
      border-radius: 5px;
      padding-left: 15px;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 24px;
      color: #383838;
      max-height: 140px;
      min-height: 40px;
    }

    button {
      margin-top: 45px;
      height: 50px;
      width: 100%;
      background: #DBBFA7;
      border: none;
      border-radius: 5px;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      color: #383838;

      &.button_component.outlined {
        border-radius: 5px;
        background-color: #fff;
        border: 2px solid #DBBFA7;
        margin-top: 10px;
      }
    }

    .avatar {
      width: 100%;
      display: flex;
      justify-content: center;
    }

  }

  .story {
    width: 50%;
    border-left: 1px solid #E5E5E5;

    a {
      text-decoration: none;

      &:active {
        color: unset;
      }

      &:focus {
        //.price {
        //  img {
        //    transform: rotate(180deg);
        //    transition: 0.4s;
        //  }
        //}
      }
    }

    .item {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #E5E5E5;

      .title {
        margin: 20px 25px 15px 20px;

        .name {
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          line-height: 24px;
          color: #383838;
        }

        .date {
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          line-height: 24px;
          color: #808080;
        }
      }

      .price {
        margin: 20px 25px 15px 20px;
        display: flex;
        align-items: center;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        color: #383838;
      }


    }
  }
}

.avatar {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 20px;

  .camera {
    position: relative;
    width: 100px;
    height: 100px;
    border-radius: 50%;

    &:hover .camera-visible {
      visibility: visible;
    }

    .camera-visible {
      visibility: hidden;
      position: absolute;
      background: rgba(56, 56, 56, 0.70);
      width: 100px;
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;

      img {
        width: 37.95px;
        height: 30.8px;
        border-radius: unset;
      }
    }
  }

  img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    object-fit: cover;
  }
}

input:disabled {
  background-color: #dbbfa7 !important;
  position: relative;
  background-image: url("/lock-solid.svg") !important;
  background-repeat: no-repeat !important;
  background-position: bottom 12px right 10px;
  background-size: 12px;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

.top_button {
  display: none;
}

@media screen and (max-width: 1170px) {
  .top_button {
    display: block;
    width: 100%;
    padding: 20px 40px 0 40px;

    button {
      background-color: transparent;
      border: none;
    }
  }
  .card .client {
    width: 100%;
    padding: 25px 40px;
  }
  .card .client button {
    max-width: 100%;
  }
}
</style>
